<template>
    <div class="col-md-12">
        <table class="table">
            <thead>
            <tr>
             <th>ลำดับ</th>
             <th>ข้อสงสัย</th>
             <th>ผู้ส่ง</th>
             <th>ความเห็นผู้เชี่ยวชาญ ศวก.</th>
             <th>ความเห็นผู้เชี่ยวชาญกรมวิทย์ฯ</th>
             <th>จัดการ</th>
            </tr>
            </thead>
            <tbody>
              <tr class="text-left" v-for="(item, index) in mushroomSend">
                  <td>
                      {{index+1}}
                  </td>
                  <td>
                    {{item.note}} <br/>
                    {{item.created_at}}
                  </td>
                  <td>{{item.user}}</td>
                  <td>{{item.ans_rmsc}}</td>
                  <td>{{item.ans_dcms}}</td>
                  <td>
                      <a :href="getUrlApprove(item.upload_code)" target="_blank"> ตอบกลับ </a>
                  </td>
              </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
  /*
  import 'vue-awesome/icons'
  import Icon from 'vue-awesome/components/Icon' */

  import axios from 'axios'
  import { mapGetters } from 'vuex'

  export default {
    name: 'sendmushroom',
    data: function () {
      return {
        loading: false,
        mushroomSend: []
      }
    },
    created () {
      if (this.getAuthen.token === '') {
        window.location.replace('/')
        return
      }
      this.fetchData()
    },
    ready () {

    },
    computed: {
      ...mapGetters([
        'getBaseUrl',
        'getAuthen'
      ])
    },
    methods: {
      getUrlApprove (code) {
        return this.getBaseUrl + '/approve/rmsc.php?code=' + code
      },
      getMushroomSend () {
        return this.getBaseUrl + '/mushroom_send.php'
      },
      fetchData () {
        var that = this
        console.log('hph_id', this.getAuthen.hph_id)
        const formData = new FormData()
        formData.append('hph_id', this.getAuthen.hph_id)
        formData.append('token', this.getAuthen.token)
        this.loading = true
        axios.post(this.getMushroomSend(), formData)
          .then(function (response) {
            var sendData = response.data
            console.log(sendData[0])
            that.loading = false
            that.mushroomSend = sendData
            // that.uploadedFiles = result
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response)
            }
          })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SendMushRoom.vue?1577aff7